import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { API, auth, PageHead } from '../finance/shared';
import VenuesTab from './VenuesTab';
import BookingsCalendarTab from './BookingsCalendarTab';
import CustomersTab from './CustomersTab';
import PaymentSettingsCard from './PaymentSettingsCard';

const TABS = [
  { key: 'venues', label: 'الملاعب' },
  { key: 'calendar', label: 'تقويم الحجوزات' },
  { key: 'customers', label: 'العملاء' },
  { key: 'payments', label: 'طرق الدفع' },
];

export default function VenueManagementPage() {
  const { user } = useOutletContext() || {};
  const canManage = !!(user?.is_super_admin || user?.role === 'admin' || user?.role === 'manager');
  const [tab, setTab] = useState('venues');
  const [venues, setVenues] = useState(null);

  const loadVenues = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/venues`, auth());
      setVenues(res.data || []);
    } catch { setVenues([]); }
  }, []);

  useEffect(() => { loadVenues(); }, [loadVenues]);

  return (
    <div className="space-y-4" data-testid="venue-management-page">
      <PageHead title="حجز الملاعب" desc="إدارة ملاعب منشأتك وجدولة الحجوزات اليومية لكل ملعب" />

      <div className="flex gap-2 border-b border-slate-200 overflow-x-auto" data-testid="venue-tabs">
        {TABS.map((t) => (
          <button
            key={t.key} onClick={() => setTab(t.key)} data-testid={`venue-tab-${t.key}`}
            className={`shrink-0 px-4 py-2.5 text-sm font-bold transition-colors ${tab === t.key ? 'border-b-2 border-teal-500 text-teal-700' : 'text-slate-500 hover:text-slate-700'}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'venues' && <VenuesTab venues={venues} canManage={canManage} onReload={loadVenues} />}
      {tab === 'calendar' && <BookingsCalendarTab venues={venues || []} canManage={canManage} />}
      {tab === 'customers' && <CustomersTab />}
      {tab === 'payments' && <PaymentSettingsCard />}
    </div>
  );
}
